import React, { useState, useCallback } from 'react';
import Modal from '../../components/Modal';
import TournamentStep from '../wizards/steps/TournamentStep';
import * as miniLeaguesApi from '../../api/miniLeagues';

/**
 * Adds another tournament to an existing league (manager only).
 *
 * Tournaments already registered are excluded — the backend rejects duplicates,
 * so they must not be offerable in the first place.
 */
function AddTournamentModal({ league, tournaments, onClose, onAdded }) {
  const [selection, setSelection] = useState({ tournamentId: '', startingMatchWeek: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSelectionChange = useCallback((next) => setSelection(next), []);

  const alreadyAdded = (league.tournaments || []).map((t) => t.tournamentId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!selection.startingMatchWeek) {
      setError('Pick a tournament and starting match week');
      return;
    }
    setSubmitting(true);
    try {
      await miniLeaguesApi.addTournament(league.id, {
        tournamentId: parseInt(selection.tournamentId),
        startingMatchWeek: parseInt(selection.startingMatchWeek),
      });
      onAdded();
    } catch (err) {
      if (err.name === 'ApiError') {
        setError(err.body?.error || 'Failed to add tournament');
      } else {
        setError('Error adding tournament');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal title="Add a Tournament" onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <p className="helper-text wizard-intro">
          Everyone already in {league.name} is entered automatically — no need to
          share the code again.
        </p>
        <TournamentStep
          tournaments={tournaments}
          value={selection}
          onChange={handleSelectionChange}
          excludeTournamentIds={alreadyAdded}
        />
        {error && <div className="error-message">{error}</div>}
        <button
          type="submit"
          className="primary-btn full-width"
          disabled={submitting || !selection.startingMatchWeek}
        >
          {submitting ? 'Adding...' : 'Add Tournament'}
        </button>
      </form>
    </Modal>
  );
}

export default AddTournamentModal;
